module.exports = __webpack_public_path__ + "static/media/38-4.19d92552.mp3";